import React from 'react';
import { ModuleBridge, TopActionBar, Button, Flex } from '../components';

export const BackupPolicies = () => {
    return (
        <>
            <TopActionBar>
                <Flex gap="small">
                    <Button type="primary" onClick={() => window.editBackupPolicy()}>
                        Add Backup Policy
                    </Button>
                </Flex>
            </TopActionBar>
            <div id="backup_policies_container"></div>
            <ModuleBridge moduleId="backup_policies" />
        </>
    );
};
